import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import QS from 'qs';

import { login, consumeAuthorizationCode } from 'store/oauth/service';
import { getCitc } from 'store/settings/service';

import { getTranslations } from './service';

const languages: any = {
  en: 'English',
  sv: 'Svenska',
  es: 'Español',
  fr: 'Français',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁體中文'
};

const getLanguages = (locales: LocalesKeys[]) => {
  Object.keys(languages).map(
    (locale: any) => !locales.includes(locale) && delete languages[locale]
  );
  return languages;
};

export const initialState: ITranslationsState = {
  locales: ['en', 'es', 'fr'],
  locale: navigator.language.substr(0, 2) as LocalesKeys,
  languages: {},
  messages: null,
  translations: null,
  loading: false,
  error: false
};

const slice = createSlice({
  name: 'intl',
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<LocalesKeys>) => {
      state.locale = action.payload;
      state.messages = state.translations && state.translations[action.payload];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTranslations.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getTranslations.fulfilled, (state, action) => {
        const params = QS.parse(window.location.search, { ignoreQueryPrefix: true });
        const locale = state.locales.find((e) => e === state.locale) || 'en';
        state.loading = false;
        state.messages = params.intlPreview ? {} : action.payload[locale];
        state.translations = action.payload;
      })
      .addCase(getTranslations.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const locale = action.payload.locale || state.locale;
        state.locale = locale;
        state.messages = state.translations && state.translations[locale];
      })
      .addCase(getCitc.fulfilled, (state, action) => {
        state.locales = action.payload.locales;
        const locale = state.locales.find((e) => e === state.locale) || 'en';
        state.locale = locale;
        state.messages = state.translations && state.translations[locale];
        state.languages = getLanguages(action.payload.locales);
      })
      .addCase(consumeAuthorizationCode.fulfilled, (state, action) => {
        const locale = action.payload.locale || state.locale;
        state.locale = locale;
        state.messages = state.translations && state.translations[locale];
      });
  }
});

// export const {} = slice.actions;
export const { setLocale } = slice.actions;
export const intlReducer = slice.reducer;
